module.exports = __webpack_public_path__ + "static/media/arrow-right.fb615e38.svg";